/* eslint-disable react/no-array-index-key */

import { BaseAttribute, AttrBoolean } from '../../types/attributes';
import { useCmsClientContext } from '../../utils/cmsPageContext/useCmsClientContext';
import { getClientTranslations } from '../../utils/translations/getClientTranslations';
import { CollapsibleSection } from '../CollapsibleSection/CollapsibleSection';
import { coverageAttributesList } from './constants';
import { TRANSLATIONS } from './i18n';
import { renderListProsCons } from './prosConsRender';

export type SectionCoverageProps = {
  isVisible: boolean;
  productAttributes: BaseAttribute[];
  toggleVisibility: () => void;
};

export const SectionCoverage: React.FC<SectionCoverageProps> = ({
  isVisible,
  productAttributes,
  toggleVisibility,
}) => {
  const context = useCmsClientContext();
  const staticText = getClientTranslations(TRANSLATIONS, context);

  const coverageAttributes = productAttributes.reduce<{
    pros: AttrBoolean[];
    cons: AttrBoolean[];
  }>(
    (accum, current) => {
      if (
        coverageAttributesList.includes(current.name?.name ?? '') &&
        current.__typename === 'ComponentAttributesAttrBoolean'
      ) {
        if (current.value) {
          accum.pros.push(current);
        } else {
          accum.cons.push(current);
        }
      }
      return accum;
    },
    { pros: [], cons: [] },
  );

  return (
    <CollapsibleSection
      id="section-coverage"
      isOpen={isVisible}
      onToggle={toggleVisibility}
      iconName="directions_car"
      iconClassName="overflow-visible size-[18px] md:size-[22px] md:mb-0 md:mr-2"
      content={
        <div className="p-3">
          <div className="grid grid-cols-1 gap-spacing/gap/soft-12px font-medium text-sm lg:text-base">
            {renderListProsCons({
              items: coverageAttributes.pros.map((a) => a.label ?? ''),
              type: 'pros',
            })}
            {renderListProsCons({
              items: coverageAttributes.cons.map((a) => a.label ?? ''),
              type: 'cons',
            })}
          </div>
        </div>
      }
    >
      <span className="mhg-alpha-bullet-2 lg:mhg-alpha-bullet-1">
        {staticText.coverage}
      </span>
    </CollapsibleSection>
  );
};
